export const API_URL = process.env.REACT_APP_API_GOB;

export const SECRET_KEY = process.env.REACT_APP_KEY;